module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "foo"
  }, [_c('H1', [_vm._v("Ocene za kurira: " + _vm._s(_vm.name))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('h3', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("Prosečna ocena " + _vm._s(_vm.averageRate))]), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed",
    staticStyle: {
      "margin-bottom": "100px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('tbody', _vm._l((_vm.rates), function(item, index) {
    return _c('tr', {
      staticStyle: {
        "color": "white",
        "background-color": "#4E5066 !important"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm.rates.length - index) + ".")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_vm._v(_vm._s(_vm.getName(item)))]), _vm._v(" "), _c('td', [_vm._l((_vm.getRate(item)), function(rate) {
      return _c('span', [_c('i', {
        staticClass: "ti-star",
        style: (_vm.getRateStyle(rate))
      })])
    }), _vm._v("\n                            \n                          "), _c('span', {
      staticStyle: {
        "color": "white"
      }
    }, [_c('b', [_vm._v(_vm._s(item.rate))])])], 2), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(item.timestamp)))])])
  }), 0)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "40px",
      "color": "white"
    }
  }, [_vm._v("R. br")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px",
      "color": "white"
    }
  }, [_vm._v("Ime")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "250px",
      "color": "white"
    }
  }, [_vm._v("Ocena")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "2000px",
      "color": "white"
    }
  }, [_vm._v("Opis")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "300px",
      "color": "white"
    }
  }, [_vm._v("Datum")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-542d91ee!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RateAndBugs/CourierRate.vue
// module id = 483
// module chunks = 1